import redirect from '../uitls/redirect';
import { notifyError, notifyInfo } from '../uitls/notification-helper';
import { MESSAGES } from '../uitls/messages';
import userService from '../api/user-service';

const state = {
    apiError: false,
    apiSuccess: false
};

const mutations = {

    setApiError(state) {
        state.apiError = true;

    },
    setApiSuccess(state) {
        state.apiSuccess = true;
    },
    reset(state) {
        state.apiError = false;
        state.apiSuccess = false;
    }
};

const getters = {

};

const actions = {
    async sendContactEmail({ commit }, userData) {
        try {
            console.log(userData);
            var response = await userService.sendContactUsEmail(userData);
            if (response.status == 200) {
                commit('setApiSuccess');
                setTimeout(() => {
                    commit('reset')
                }, 5000)
            }
            else {
                commit('setApiError')
                setTimeout(() => {
                    commit('reset');
                }, 5000)
            }
        }
        catch (err) {
            commit('setApiError')
            setTimeout(() => {
                commit('reset');
            }, 5000)
        }
    }
};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {

    }
}